export default __webpack_public_path__ + "static/media/April2011.d821ee59.png";